import { firebaseAction } from "vuexfire";
// import { rtDb } from "@/db";
import firebase from "firebase/app";
import "firebase/database";
export default {
  namespaced: true,
  state: () => ({
    meta: {}
  }),
  actions: {
    bindMeta: firebaseAction(({ bindFirebaseRef }) => {
      // binds the documents collection onto the `state.documents` property
      // `bindFirebaseRef` also automatically unbinds any previously bound reference on the same property `documents`
      bindFirebaseRef("meta", firebase.database().ref("_meta"));
    })
  },
  getters: {
    projects: state => {
      return state.meta.projects;
    },
    projectArray: state => {
      if (!state.meta || !state.meta.projects) {
        return [];
      }
      const projects = state.meta.projects;
      const arr = [];
      for (let k in projects) {
        const p = projects[k];
        p.id = k;
        arr.push(p);
      }
      return arr;
    },
    leadSources: state => state.meta.leads.sources,
    contactGroups: state => state.meta.contacts.groups
  }
};
